import SALARYOFFEREDVSWANTED from 'data/mantechcar24/salary-offered-vs-wanted.json';
import { useI18n } from 'hooks/useI18n';
import { useRouter } from 'next/router';
import {
  Bar,
  BarChart,
  Legend,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis
} from 'recharts';
import { StyledRecharts } from '../../shared/recharts/Recharts.styled';

const SalaryOfferedVsWanted: React.FC = () => {
  const { t } = useI18n('developer-career-report-2024');
  const { locale } = useRouter();

  return (
    <div>
      <StyledRecharts className="xAxisLabel">
        <ResponsiveContainer width="99%" height={950} minWidth={500}>
          <BarChart data={SALARYOFFEREDVSWANTED} layout="vertical">
            <XAxis
              type="number"
              allowDecimals={false}
              tickLine={false}
              padding={{ left: 20 }}
              tickFormatter={(tick) => {
                return `${tick / 1000}K`;
              }}
            ></XAxis>
            <YAxis
              type="category"
              dataKey="role"
              tickLine={false}
              width={200}
            />
            <Tooltip
              cursor={{ fill: '#ebe8df' }}
              labelStyle={{ display: 'none' }}
              separator=": "
              formatter={(value: number) => `€${value.toLocaleString(locale)}`}
              wrapperClassName="tooltip-y"
            />
            <Legend
              layout="horizontal"
              iconType="square"
              wrapperStyle={{ bottom: 0 }}
            />
            <Bar
              dataKey="offered"
              name={t('mantechcar24.companies.salary-offered-wanted.offered')}
              fill="#7EAFD3"
              barSize={8}
              radius={5}
            />
            <Bar
              dataKey="desired"
              name={t('mantechcar24.companies.salary-offered-wanted.desired')}
              fill="#8DD3C7"
              barSize={8}
              radius={5}
            />
          </BarChart>
        </ResponsiveContainer>
      </StyledRecharts>
    </div>
  );
};

export default SalaryOfferedVsWanted;
